/* eslint-disable*/
import { Link } from "react-router-dom";

function StoryPage(story) {

	const renderImages = () => {
		const images = story.story?.storyImages?.[0]?.storyImages;
		if (!images || images.length === 0) return null;

		return (
			<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 m-8">
				{images.map((image, index) => (
					<div key={index} className="relative group">
						<img
							src={image?.small?.url}
							alt={`Story Image ${index + 1}`}
							className="w-full h-56 object-cover rounded-xl shadow-md "
						/>
						{/* <div className="absolute inset-0 flex justify-center items-center bg-black bg-opacity-30 opacity-0 group-hover:opacity-100 transition-opacity">
							<span className="text-white text-lg">View Image</span>
						</div> */}
					</div>
				))}
			</div>
		);
	};

	const renderSection = (title, content) => (
		<section className="mt-6 p-6 bg-mild-100 rounded-xl shadow-md">
			<h3 className="text-2xl font-semibold text-gray-800">{title}</h3>
			<p className="mt-2 text-lg text-gray-700">{content || "Not provided"}</p>
		</section>
	);

	return (
		<>
			<div className="bg-gradient-to-b from-gray-50 to-gray-200 min-h-screen py-6 relative">
					<main className="container mx-auto px-6 lg:px-8 z-10">
						{/* Hero section */}
						<header className="text-center mb-8">
							{/* Animated Blog Title */}
							<h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-transparent bg-clip-text bg-success-800 leading-tight animate__animated animate__fadeIn animate__delay-1s z-10">
								{story.story.blogTitle}
							</h1>

							{/* Author Name with Icon and Fun Styling */}
							<p className="text-lg sm:text-xl text-gray-600 mt-3 font-semibold z-10">
								<span role="img" aria-label="Author" className="text-3xl mr-2">✍️</span>
								by <span className="font-bold text-primary-400">{story.story.firstName} {story.story.lastName}</span>
							</p>
						</header>

						{/* Images Section */}
						{renderImages()}

						{/* Content Sections */}
						<div className="bg-white shadow-md rounded-lg p-6 mb-8 z-10">
							{renderSection("Brief description of your organization", story.story.orgDescription)}
							{renderSection("How did you use COhatch this year to support your organization?", story.story.prompts?.support)}
							{renderSection("How many times did you use a COhatch location this year?", story.story.prompts?.amountUsed)}
							{renderSection("Did COhatch help you create connections, receive funding, or other metrics this year?", story.story.prompts?.metrics)}
							{renderSection("Details related to networking, funding, and investment", story.story.prompts?.howWeHelped)}
							{renderSection("Feedback about COhatch and this scholarship", story.story.prompts?.feedback)}
							{renderSection(
								"Social media link mentioning COhatch",
								<a
									href={story.story.prompts?.socialMediaLink}
									target="_blank"
									rel="noopener noreferrer"
									className="text-primary-400 underline hover:text-primary-600 cursor-pointer"
								>
									{story.story.prompts?.socialMediaLink || "Not provided"}
								</a>
							)}
						</div>
					</main>
				</div>
		</>
	);
}

export default StoryPage;
